export default "__VITE_ASSET__Bmf5rEq9__"